import { API } from '../config';
import { getEnv } from './env';

function sendLog(logLevel: keyof typeof logger, message: any, args: any[]) {
  const logBody = {
    level: logLevel,
    message,
    service: `client:core-frontend`,
    ddtags: `env:${getEnv()},client:core-frontend`,
    arguments: args.map((a) => (a instanceof Error ? JSON.stringify(a, Object.getOwnPropertyNames(a)) : a)),
  };
  fetch(`${API.baseURL}log`, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(logBody),
  }).then(() => {
    // eslint-disable-next-line no-console
    console[logLevel](message, ...args);
  });
}

export const logger = {
  debug: (message: any, ...args: any[]) => sendLog('debug', message, args),
  info: (message: any, ...args: any[]) => sendLog('info', message, args),
  warn: (message: any, ...args: any[]) => sendLog('warn', message, args),
  error: (message: any, ...args: any[]) => sendLog('error', message, args),
};
